import script from "./user-orders.vue?vue&type=script&setup=true&lang=js"
export * from "./user-orders.vue?vue&type=script&setup=true&lang=js"

import "./user-orders.vue?vue&type=style&index=0&id=f80d96f4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f80d96f4"]])

export default __exports__